
import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../config/AuthContext";
import Login from "../../Login";
import { Content } from "antd/es/layout/layout";
import AppSiderActivitatsId from "./menus/AppSiderActivitatsId";
import ActivitatsIdExercicis from "./content/ActivitatsIdExercicis";
import ActivitatsIdAlumnes from "./content/ActivitatsIdAlumnes";
import ActivitatsIdEstadistiques from "./content/ActivitatsIdEstadistiques";
import { GetPractica } from "../../../dao/jutge/GetPracticaId";
import { GetAlumneId } from "../../../dao/GetAlumneId";
import UseWebSocketSubscription from "../../UseWebSocketSubscription";

const ActivitatsId = ({ page }: { page: number }) => {
    const { isLoggedIn, userId, user, setBreadCrumb, alumne, setAlumneInfo } = useContext(AuthContext);
    const { id_activitat } = useParams();
    const navigate = useNavigate();
    const [pantalla, setPantalla] = useState(page);
    const [loading, setLoading] = useState(true);

    UseWebSocketSubscription(["/topic/home"], () => {
        checkDades();
    });


    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
            setPantalla(page)
            setPnt(page);
            //console.log(page);
        }
    }, [id_activitat]);

    async function checkDades() {
        setLoading(true);
        const act = await GetPractica(id_activitat + "");

        if (!act) {
            navigate('/jutge/activitats');
            setLoading(false);
            return;
        }

        // Admin/Professor pass
        if (["0", "1"].includes(user.tipus)) {
            setLoading(false);
            return;
        }

        // Check Modo Examen del aula para alumnos:
        if (act) {
            let userAulas = alumne?.aules || [];
            if (userId) {
                try {
                    const al = await GetAlumneId(userId);
                    if (al?.aules) {
                        userAulas = al.aules;
                        if (setAlumneInfo) setAlumneInfo(al);
                    }
                } catch (e) {
                    // fallback
                }
            }
            const currentAula = (userAulas || []).find((a: any) => String(a.id || a.id_aula) === String(act.id_aula));
            const isAulaExamMode = currentAula && Boolean(currentAula.isExamen === 1 || currentAula.isExamen === true || currentAula.is_examen === 1 || currentAula.is_examen === true);

            // En modo examen, las actividades regulares están completamente bloqueadas para los alumnos -> redirigir a examenes
            if (isAulaExamMode) {
                navigate('/jutge/examens');
                setLoading(false);
                return;
            }
        }

        const now = new Date();
        const start = act.inici ? new Date(act.inici) : null;
        const end = act.final ? new Date(act.final) : null;

        // Check 1: Activity state (estat)
        // estat 1: hidden/draft?
        if (act.estat === 1) {
            navigate('/jutge/activitats');
            setLoading(false);
            return;
        }

        // Check 2: Dates logic
        // If has start date and now is before start
        if (start && now < start) { 
            navigate('/jutge/activitats');
            setLoading(false);
            return;
        }

        // If has end date and now is after end (and not extended/TimeJavamon?)
        // Usually read-only access is allowed after finish, so blocking might be too aggressive?
        // But if 'active' access is required, check constraints.
        // For now, let's assume we block future access before start, and hidden state.

        setLoading(false);
    }

    function setPnt(value: number) {
        setPantalla(value);
    }

    if (isLoggedIn) {
        return (
            <>
                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh', width: '100%' }}>
                        {/* One day we will add a spinner here */}
                    </div>
                ) : (
                    <>
                        <AppSiderActivitatsId setPantalla={setPnt} initialPantalla={page || 0} />
                        <Content style={{ padding: '0 24px', minHeight: 280 }}>
                            {pantalla === 0 && <ActivitatsIdExercicis />}
                            {pantalla === 1 && <ActivitatsIdAlumnes />}
                            {pantalla === 2 && <ActivitatsIdEstadistiques />}
                        </Content>
                    </>
                )}
            </>
        );
    } else {
        return (
            <Login />
        );
    }
};

export default ActivitatsId;
